<template>
  <div id="header-top">
    <nav class="navbar navbar-expand-sm bg-dark navbar-dark navbar-position">
      <div class="container-fluid">
        <a class="navbar-brand" href="#" style="color:white; margin-left:80px;">{{ title }} - <span style="font-size: 0.8em;">v{{ version }}</span></a>

        <ul class="nav navbar-nav ms-auto">
          <li class="nav-item dropdown">
            <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
              <img alt="Vue logo" src="../assets/user.svg" width="30">

            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <a @click="getManual" class="dropdown-item">Manual</a>
              <a @click="onMenuClick('/versions')" class="dropdown-item">Versions</a>
              <div class="dropdown-divider"></div>
              <a @click="logOut" class="dropdown-item">Logout</a>
            </div>
          </li>
        </ul>
      </div>
    </nav>

  </div>




  <div id="header-top-mobile">

    <nav class="navbar navbar-expand-lg navbar-dark bg-dark vop-head-color">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">E.M.S - v{{ version }}</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link" style="cursor:pointer" @click="onMenuClick('/monitordashboard')">Monitor Dashboard</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" style="cursor:pointer" @click="onMenuClick('/monitordetail')">Monitor Details</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" style="cursor:pointer" @click="onMenuClick('/predictiondashboard')">Prediction
                Dashboard</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" style="cursor:pointer" @click="onMenuClick('/PredictionDetail')">Prediction Details</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" style="cursor:pointer" @click="onMenuClick('/reports')">Reports</a>
            </li>
            <li class="nav-item" v-if="isAdmin">
              <a class="nav-link" style="cursor:pointer" @click="onMenuClick('/administration-dashboard')">Administration
                Dashboard</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" style="cursor:pointer" @click="onMenuClick('/Versions')">Versions</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" style="cursor:pointer" @click="logOut">Log Out</a>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import TokenService from "../services/token.service";

export default {
  name: 'HeaderBarMenu',
  props: {
    title: String
  },

  data() {
    return {
    };
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
    isAdmin() {
      if (sessionStorage.getItem("user") == null) {
        return false;
      }
      let user = TokenService.getUser();
      let role = user.role;

      if (role > 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {

  },
  methods: {
    onMenuClick(link) {
      this.$router.push(link);
    },
    logOut() {
      this.$store.dispatch("logout");
    },
    getManual() {
      window.open("https://ems.olympusmarinegroup.com/manuals/ems-manual.pdf");
    }
  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
